import { RuleGroupType, RuleGroupTypeIC } from 'react-querybuilder';

export const defaultNullRelatedOperators = {
  null: 'IS NULL',
  notNull: 'IS NOT NULL',
};

export const defaultConstraintsOperators = [
  { name: '=', label: '=' },
  { name: '<>', label: '!=' },
  { name: '<', label: '<' },
  { name: '>', label: '>' },
  { name: '<=', label: '<=' },
  { name: '>=', label: '>=' },
  { name: 'LIKE', label: 'contains' },
  { name: 'NOT LIKE', label: 'does not contain' },
  // { name: 'beginsWith', label: 'begins with' },
  // { name: 'endsWith', label: 'ends with' },
  // { name: 'doesNotBeginWith', label: 'does not begin with' },
  // { name: 'doesNotEndWith', label: 'does not end with' },
  { name: defaultNullRelatedOperators.null, label: 'is null' },
  { name: defaultNullRelatedOperators.notNull, label: 'is not null' },
  // { name: 'in', label: 'in' }, not available
  // { name: 'notIn', label: 'not in' }, not available
  // { name: 'between', label: 'between' }, not available
  // { name: 'notBetween', label: 'not between' }, not available
];

export const commonConstraintsAllowedOperators = [
  { name: '=', label: '=' },
  { name: '<>', label: '!=' },
  { name: defaultNullRelatedOperators.null, label: 'is null' },
  { name: defaultNullRelatedOperators.notNull, label: 'is not null' },
];

export const numberConstraintsAllowedOperators = [
  { name: '<', label: '<' },
  { name: '>', label: '>' },
  { name: '<=', label: '<=' },
  { name: '>=', label: '>=' },
];

export const mappedConstraintsAllowedOperators = {
  String: [
    ...commonConstraintsAllowedOperators,
    { name: 'LIKE', label: 'contains' },
    { name: 'NOT LIKE', label: 'does not contain' },
  ],
  Integer: [...commonConstraintsAllowedOperators, ...numberConstraintsAllowedOperators],
  Number: [...commonConstraintsAllowedOperators, ...numberConstraintsAllowedOperators],
  Date: [...commonConstraintsAllowedOperators, ...numberConstraintsAllowedOperators],
  DateImagedMaxMin: [
    ...commonConstraintsAllowedOperators,
    ...numberConstraintsAllowedOperators,
  ],
};

/**
 * To accomodate RQB for mapping types.
 */
export const classTypeMappingToInputTypeMapping = {
  Date: 'date',
  Integer: 'number',
  Number: 'number',
  DateImagedMaxMin: 'date',
};

export type ConstraintsQueryType = RuleGroupType | RuleGroupTypeIC;
